import React, { useState, useEffect } from 'react';
import UPIPayment from './upipayment';

function PlanSelectionPage() {
  const [plans, setPlans] = useState([]);
  const [selectedPlanId, setSelectedPlanId] = useState(null);

  const getIcon = (planName) => {
    if (planName.includes("Basic")) return "🔰";
    if (planName.includes("Advanced")) return "⚙️";
    if (planName.includes("Premium")) return "🚀";
    if (planName.includes("100")) return "📦";
    if (planName.includes("500")) return "📦📦";
    return "📊";
  };

  const toTitleCase = (str) => str
    .toLowerCase()
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  useEffect(() => {
    fetch('http://localhost:8000/api/payment/plans/')
      .then(res => res.json())
      .then(data => setPlans(data.plans));
  }, []);

  if (selectedPlanId) {
    return <UPIPayment planId={selectedPlanId} />;
  }

  const getPlanFeatures = (planName) => {
    if (planName.includes("Basic")) {
      return [
        "Price Charting & Technical Indicators",
        "5 Recent Stock Strategy Results",
        "Nifty200 Market Summary View",
        "Monthly Sector Performance Dashboard",
      ];
    }
    if (planName.includes("Advanced")) {
      return [
        "Everything in Basic",
        "Momentum & Growth Screeners (Live)",
        "Options Chain & PCR Visualizer",
        "Daily & Monthly Market Newsletter Access",
        "Limited API Usage (200 calls/month)",
      ];
    }
    if (planName.includes("Premium")) {
      return [
        "Everything in Advanced",
        "VaR, CVaR, Monte Carlo, Greeks Analyzer",
        "Scenario Stress Testing (Equity + Options)",
        "High-Volume Dashboard for F&O Traders",
        "Unlimited API Calls + Portfolio Integration",
      ];
    }
    if (planName.includes("100")) {
      return ["100 API Calls - Usage Valid 90 Days"];
    }
    if (planName.includes("500")) {
      return ["500 API Calls - Usage Valid 90 Days"];
    }
    return ["Standard Plan"];
  };

  // --- Style constants ---
  const styles = {
    container: {
      padding: '30px',
      fontFamily: 'Arial, sans-serif',
    },
    grid: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '20px',
      justifyContent: 'center',
    },
    card: {
      border: '1px solid #ddd',
      borderRadius: '12px',
      padding: '20px',
      width: '280px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      backgroundColor: '#fff',
    },
    icon: {
      fontSize: '36px',
      marginBottom: '10px',
    },
    button: {
      marginTop: '15px',
      padding: '10px 15px',
      backgroundColor: '#007bff',
      color: '#fff',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
    },
    featureList: {
      padding: 0,
      listStyle: 'none',
      fontSize: '14px',
    },
    featureItem: {
      marginBottom: '6px',
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Choose a Membership Plan</h2>
      {plans.length === 0 ? (
        <p>Loading plans...</p>
      ) : (
        <div style={styles.grid}>
          {plans.map(plan => (
            <div key={plan.id} style={styles.card}>
              <div style={styles.icon}>{getIcon(plan.name)}</div>
              <h3>{toTitleCase(plan.name)}</h3>
              <p><strong>₹{plan.price}</strong> / {toTitleCase(plan.billing_cycle)}</p>
              <ul style={styles.featureList}>
                {getPlanFeatures(plan.name).map((feature, i) => (
                  <li key={i} style={styles.featureItem}>✅ {feature}</li>
                ))}
              </ul>
              <button
                style={styles.button}
                onClick={() => setSelectedPlanId(plan.id)}
              >
                Subscribe
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default PlanSelectionPage;
